export default {
  common: {
    appName: 'UniPortal',
    byUnifiber: 'door Unifiber',
    copyright: '© {{year}} Unifiber — UniPortal',
    nav: { documents: 'Documenten', publishing: 'Publiceren', collections: 'Collecties', channels: 'Dropmappen', users: 'Gebruikers', publishers: 'Categorieën', guide: 'Gids' },
    signOut: 'Afmelden',
    loading: 'Laden…',
    cancel: 'Annuleren',
    save: 'Opslaan',
    close: 'Sluiten',
    search: 'Zoeken',
    retry: 'Opnieuw proberen',
    error: 'Er is iets misgegaan. Probeer het opnieuw.',
    uncategorized: 'Niet-gecategoriseerd',
  },
  auth: {
    login: {
      title: 'Aanmelden',
      subtitle: 'Toegang tot documenten die met u zijn gedeeld',
      emailLabel: 'E-mailadres',
      emailPlaceholder: 'u@bedrijf.com',
      passwordLabel: 'Wachtwoord',
      passwordPlaceholder: 'Uw wachtwoord',
      forgotPassword: 'Wachtwoord vergeten?',
      signIn: 'Aanmelden',
      signingIn: 'Aanmelden…',
      or: 'OF',
      microsoftSso: 'Aanmelden met Microsoft',
      ssoUnavailable: 'Aanmelden met Microsoft is niet beschikbaar',
      errorBothFields: 'Vul uw e-mailadres en wachtwoord in.',
      errorGeneric: 'Aanmelden mislukt. Probeer het opnieuw.',
      ssoErrors: {
        denied: 'Aanmelden met Microsoft is geweigerd. Neem contact op met uw beheerder als u denkt dat dit een vergissing is.',
        server_error: 'Aanmelden met Microsoft is tijdelijk niet beschikbaar. Probeer het later opnieuw.',
        unknown: 'Aanmelden met Microsoft is mislukt. Probeer het opnieuw.',
      },
      noAccount: 'Accounts worden aangemaakt door uw beheerder.',
    },
    twofactor: {
      title: 'Tweefactorauthenticatie',
      subtitle: 'Voer de 6-cijferige code uit uw authenticator-app in',
      verify: 'Verifiëren',
      verifying: 'Verifiëren…',
      rememberDevice: 'Dit apparaat 30 dagen onthouden',
      useRecovery: 'Gebruik een herstelcode',
      recoveryTitle: 'Herstelcode',
      recoverySubtitle: 'Voer een van uw eenmalige herstelcodes in',
      recoveryPlaceholder: 'bv. A1B2C3D4',
      backToCode: 'Terug naar authenticatorcode',
      remainingCodes: '{{count}} herstelcodes over',
      invalidCode: 'Ongeldige code. Probeer het opnieuw.',
      sessionExpired: 'Uw aanmeldsessie is verlopen. Ga terug en meld u opnieuw aan.',
      backToLogin: 'Terug naar aanmelden',
    },
    totpSetup: {
      title: 'Tweefactorauthenticatie instellen',
      subtitle: 'Beveilig uw account met een authenticator-app',
      step1: 'Scan deze QR-code met uw authenticator-app (Microsoft Authenticator, Google Authenticator, …)',
      manualEntry: 'Of voer deze sleutel handmatig in:',
      step2: 'Voer daarna de 6-cijferige code uit de app in om te bevestigen',
      confirm: 'Bevestigen',
      confirming: 'Bevestigen…',
      recoveryTitle: 'Bewaar uw herstelcodes',
      recoverySubtitle:
        'Elke code kan eenmalig worden gebruikt om aan te melden als u geen toegang meer heeft tot uw authenticator. Bewaar ze veilig — ze worden niet opnieuw getoond.',
      download: 'Download .txt',
      copy: 'Kopiëren',
      copied: 'Gekopieerd',
      savedConfirm: 'Ik heb mijn herstelcodes bewaard',
      continue: 'Doorgaan naar UniPortal',
    },
    forceChange: {
      title: 'Nieuw wachtwoord instellen',
      subtitle: 'Uw wachtwoord is verlopen en moet worden gewijzigd',
      newPassword: 'Nieuw wachtwoord',
      confirmPassword: 'Bevestig nieuw wachtwoord',
      mismatch: 'De wachtwoorden komen niet overeen.',
      submit: 'Wachtwoord wijzigen',
      submitting: 'Wijzigen…',
      policy: {
        minLength: 'Minstens 12 tekens',
        upper: 'Eén hoofdletter',
        lower: 'Eén kleine letter',
        number: 'Eén cijfer',
      },
    },
    forgot: {
      title: 'Wachtwoord opnieuw instellen',
      subtitle: 'Vul uw e-mailadres in en wij sturen u een herstellink',
      submit: 'Herstellink versturen',
      submitting: 'Versturen…',
      sentNote: 'Als er een account met dit e-mailadres bestaat, is er een herstellink verzonden.',
      backToLogin: 'Terug naar aanmelden',
    },
    reset: {
      title: 'Kies een nieuw wachtwoord',
      subtitle: 'Stel het nieuwe wachtwoord voor uw account in',
      totpLabel: 'Authenticatorcode',
      totpNote: 'Dit account gebruikt tweefactorauthenticatie — voer de 6-cijferige code uit uw app in.',
      submit: 'Wachtwoord opnieuw instellen',
      submitting: 'Instellen…',
      success: 'Uw wachtwoord is opnieuw ingesteld. U kunt nu aanmelden.',
      goLogin: 'Naar aanmelden',
      invalid: 'Deze herstellink is ongeldig of verlopen.',
    },
  },
  dashboard: {
    greeting: 'Hallo {{name}}',
    title: 'Uw documenten',
    subtitle: 'Alles wat met u is gedeeld, op één plek.',
    searchPlaceholder: 'Filter op titel of collectie…',
    ungrouped: 'Overige documenten',
    open: 'Openen',
    updated: 'Bijgewerkt {{date}}',
    emptyTitle: 'Nog geen documenten',
    emptyBody: 'Er zijn nog geen documenten met u gedeeld — neem contact op met uw beheerder.',
    errorLoad: 'Uw documenten konden niet worden geladen.',
    retry: 'Opnieuw proberen',
    noMatches: 'Geen documenten komen overeen met uw filter.',
  },
  viewer: {
    loading: 'Document openen…',
    unavailableTitle: 'Document niet beschikbaar',
    unavailableBody: 'Dit document is niet langer beschikbaar, of uw toegang is gewijzigd.',
    backToDocuments: 'Terug naar documenten',
    reload: 'Document herladen',
  },
  publish: {
    title: 'Publiceren',
    subtitle: 'Upload zelfstandige HTML-documenten en beheer wie ze mag lezen.',
    publisherLabel: 'Categorie',
    publisherScopeHint: 'De documenten en collecties hieronder horen bij deze categorie. Ontvangers worden gekozen uit de volledige gebruikersdirectory.',
    noPublisher: 'Uw account beheert geen categorie. Neem contact op met de platformbeheerder.',
    upload: {
      title: 'Document publiceren',
      drop: 'Sleep een HTML-bestand hierheen',
      browse: 'of bladeren',
      titleLabel: 'Titel (optioneel — standaard de bestandsnaam)',
      titlePlaceholder: 'bv. Weekrapport — Circet',
      expiryLabel: 'Vervaldatum (optioneel)',
      grantsLabel: 'Toegang geven aan',
      grantsHint: 'U kunt de toegang ook na publicatie beheren.',
      submit: 'Publiceren',
      uploading: 'Publiceren…',
      success: '"{{title}}" is gepubliceerd.',
      validatorOk: 'Zelfstandigheidscontrole geslaagd.',
      validatorWarn: 'Advies: externe verwijzingen gevonden ({{count}}). De sandbox blokkeert ze bij het bekijken.',
      onlyHtml: 'Alleen .html-bestanden worden geaccepteerd.',
      noGrantsWarn: 'Gepubliceerd — maar nog met niemand gedeeld. Gebruik “Toegang beheren” om lezers toe te voegen.',
      collectionLabel: 'Collecties',
      collectionHint: 'optioneel — een of meer',
      noCollection: '— geen (niet gegroepeerd) —',
      noCollectionsYet: 'Nog geen collecties — het document komt in “Niet-gecategoriseerd”.',
      dupSameDept: 'Dit document is al in deze categorie gepubliceerd.',
    },
    docs: {
      title: 'Gepubliceerde documenten',
      empty: 'Nog niets gepubliceerd. Uw eerste document verschijnt hier.',
      notShared: 'Niet gedeeld',
      notSharedHint: 'Gepubliceerd maar aan niemand toegekend — geen enkele lezer kan het zien.',
      cols: {
        title: 'Titel',
        status: 'Status',
        selfContained: 'Zelfstandig',
        version: 'v',
        updated: 'Bijgewerkt',
        access: 'Toegang',
        actions: '',
      },
      manageAccess: 'Toegang beheren',
      edit: 'Bewerken',
      users: '{{count}} gebruikers',
      ownerDept: 'Eigenaarscategorie',
      linkedDept: 'Gekoppelde categorie',
    },
    edit: {
      title: 'Document bewerken',
      titleLabel: 'Titel',
      displayNameLabel: 'Weergavenaam voor jouw categorie (optioneel)',
      secondaryHint: 'Dit document is eigendom van een andere categorie. Je kunt de collecties en toegang ervan voor jouw categorie beheren en het een eigen weergavenaam geven — maar niet de titel wijzigen of het verwijderen.',
      collectionLabel: 'Collecties',
      expiryLabel: 'Vervaldatum (optioneel)',
      save: 'Wijzigingen opslaan',
      saved: 'Document bijgewerkt.',
      unlink: 'Uit mijn categorie verwijderen',
      unlinkConfirm: 'Dit document uit jouw categorie verwijderen? Het blijft beschikbaar voor de eigenaarscategorie.',
      unlinked: 'Uit jouw categorie verwijderd.',
    },
    link: {
      title: 'Dit document bestaat al',
      subtitle: '“{{title}}” is al gepubliceerd door {{owner}}. Koppel het aan je collecties in plaats van een kopie te uploaden.',
      nameLabel: 'Weergavenaam voor jouw categorie (optioneel)',
      namePlaceholder: 'Oorspronkelijke titel behouden',
      collectionsLabel: 'Aan je collecties toevoegen',
      submit: 'Aan mijn categorie koppelen',
      success: 'Document aan jouw categorie gekoppeld.',
    },
    status: { PUBLISHED: 'Gepubliceerd', DRAFT: 'Concept', EXPIRED: 'Verlopen', DELETED: 'Verwijderd' },
    access: {
      title: 'Wie mag "{{title}}" lezen?',
      subtitle: 'Iedereen op het platform kan toegang tot dit document krijgen.',
      searchUsers: 'Gebruikers filteren…',
      noUsers: 'Nog geen gebruikers op het platform — maak ze aan onder Gebruikers.',
      save: 'Toegang opslaan',
      saved: 'Toegang bijgewerkt: {{added}} toegevoegd, {{removed}} verwijderd.',
    },
  },
  admin: {
    title: 'Gebruikers',
    subtitle: 'Externe accounts die kunnen aanmelden bij UniPortal.',
    create: 'Nieuwe gebruiker',
    searchPlaceholder: 'Zoek op naam, e-mail of bedrijf…',
    cols: {
      name: 'Naam',
      company: 'Bedrijf',
      auth: 'Aanmelding',
      publishers: 'Categorieën',
      status: 'Status',
      twofa: '2FA',
      lastLogin: 'Laatste aanmelding',
    },
    active: 'Actief',
    inactive: 'Inactief',
    never: 'Nooit',
    platformAdmin: 'Platformbeheerder',
    allPublishers: 'Alle categorieën',
    dialog: {
      createTitle: 'Gebruiker aanmaken',
      editTitle: 'Gebruiker bewerken',
      saveChanges: 'Opslaan',
      email: 'E-mailadres',
      displayName: 'Weergavenaam',
      company: 'Bedrijf (optioneel)',
      language: 'Taal',
      authType: 'Aanmeldmethode',
      authTypes: {
        LOCAL: 'Wachtwoord + authenticator (externe gebruiker)',
        ENTRA_ID: 'Alleen Microsoft SSO',
        BOTH: 'Microsoft SSO of wachtwoord',
      },
      publisher: 'Categorie',
      noPublisherOption: '— geen —',
      publisherRole: 'Rol binnen de categorie',
      publisherRoles: { VIEWER: 'Lezer', PUBLISHER_ADMIN: 'Uitgeverbeheerder' },
      role: 'Platformrol',
      roles: { VIEWER: 'Standaard', PLATFORM_ADMIN: 'Platformbeheerder' },
      userType: 'Gebruikerstype',
      userTypes: { REGULAR: 'Gewone gebruiker', PUBLISHER: 'Uitgever', ADMIN: 'Beheerder' },
      department: 'Categorie',
      departmentPlaceholder: '— kiezen —',
      categories: 'Categorieën',
      categoriesHint: 'een of meer',
      noCategories: 'Nog geen categorieën.',
      submit: 'Gebruiker aanmaken',
      creating: 'Aanmaken…',
      created: '{{email}} aangemaakt — welkomstmail verzonden.',
      convertTitle: 'Aanmeldmethode wijzigen',
      convertSubmit: 'Wijzigen',
    },
    actions: {
      menu: 'Acties',
      edit: 'Bewerken…',
      manageGrants: 'Toegang beheren',
      resendWelcome: 'Welkomstmail opnieuw versturen',
      resetPassword: 'Wachtwoordherstel versturen',
      reset2fa: '2FA opnieuw instellen',
      convertAuth: 'Aanmeldmethode wijzigen',
      deactivate: 'Deactiveren',
      activate: 'Activeren',
      delete: 'Verwijderen…',
      confirmDelete: '{{name}} verwijderen? Toegang en apparaten worden definitief verwijderd.',
    },
    toast: {
      welcomeSent: 'Welkomstmail verzonden.',
      resetSent: 'Herstelmail verzonden.',
      twofaReset: '2FA is opnieuw ingesteld.',
      converted: 'Aanmeldmethode bijgewerkt.',
      updated: 'Gebruiker bijgewerkt.',
      deleted: 'Gebruiker verwijderd.',
    },
    grants: {
      title: 'Toegang beheren — {{name}}',
      subtitle: 'Kies de collecties en losse documenten die deze persoon mag lezen.',
      collections: 'Collecties',
      documents: 'Losse documenten',
      noCollections: 'Geen collecties beschikbaar.',
      nonCollection: 'Niet-gecategoriseerd',
      nonCollectionHint: '(documenten in geen enkele collectie)',
      searchDocs: 'Zoek een document om toe te voegen…',
      noDocs: 'Geen documenten beschikbaar.',
      added: 'Toegevoegd',
      saved: 'Toegang bijgewerkt.',
      save: 'Toegang opslaan',
    },
  },
  publishers: {
    title: 'Categorieën',
    subtitle: 'Interne categorieën die documenten publiceren via UniPortal.',
    create: 'Nieuwe categorie',
    cols: {
      name: 'Naam',
      slug: 'Slug',
      status: 'Status',
      members: 'Uitgevers',
      documents: 'Documenten',
      collections: 'Collecties',
    },
    active: 'Actief',
    disabled: 'Uitgeschakeld',
    empty: 'Nog geen categorieën. Maak de eerste aan om te beginnen met publiceren.',
    dialog: {
      createTitle: 'Categorie aanmaken',
      renameTitle: 'Categorie hernoemen',
      name: 'Naam',
      namePlaceholder: 'bv. HC Contractor Reports',
      slug: 'Slug (optioneel)',
      slugHint: 'Kleine letters, cijfers en koppeltekens. Gebruikt in opslag- en synchronisatiepaden — kan later niet worden gewijzigd. Automatisch gegenereerd uit de naam indien leeg gelaten.',
      submit: 'Categorie aanmaken',
      creating: 'Aanmaken…',
      save: 'Opslaan',
      saving: 'Opslaan…',
    },
    actions: {
      menu: 'Acties',
      rename: 'Hernoemen',
      disable: 'Uitschakelen',
      enable: 'Inschakelen',
      manageCollections: 'Collecties beheren',
      manageAdmins: 'Uitgevers beheren',
      delete: 'Verwijderen…',
      confirmDelete: 'Categorie "{{name}}" verwijderen? Dit verwijdert ook de collecties en lidmaatschappen.',
    },
    collections: {
      title: 'Collecties — {{name}}',
      subtitle: 'Groepen documenten binnen deze categorie (bijv. één per aannemer).',
      add: 'Collectie toevoegen',
      namePlaceholder: 'Naam van de collectie',
      empty: 'Nog geen collecties.',
      documentsCount: '{{count}} documenten',
      delete: 'Verwijderen',
      confirmDelete: 'Collectie "{{name}}" verwijderen?',
      close: 'Sluiten',
    },
    admins: {
      title: 'Uitgevers — {{name}}',
      subtitle: 'Personen die de inhoud van deze categorie mogen publiceren en beheren.',
      search: 'Zoek een gebruiker om als uitgever toe te voegen…',
      current: 'Huidige uitgevers',
      none: 'Nog geen uitgevers.',
      noResults: 'Geen overeenkomende gebruikers.',
      remove: 'Verwijderen',
      close: 'Sluiten',
    },
    toast: {
      created: 'Categorie "{{name}}" aangemaakt.',
      updated: 'Categorie bijgewerkt.',
      deleted: 'Categorie verwijderd.',
      disabled: 'Categorie uitgeschakeld.',
      enabled: 'Categorie ingeschakeld.',
      collectionCreated: 'Collectie toegevoegd.',
      collectionDeleted: 'Collectie verwijderd.',
      adminAdded: 'Uitgever toegevoegd.',
      adminRemoved: 'Uitgever verwijderd.',
      hasDocuments: 'Deze categorie heeft nog documenten — schakel hem in plaats daarvan uit.',
    },
  },
  collections: {
    title: 'Collecties',
    subtitle:
      'Groepeer de documenten van een categorie (bv. één collectie per onderaannemer). Geef gebruikers toegang tot een collectie en elk document erin — ook toekomstige SFTP/sync-bestanden — wordt voor hen beschikbaar.',
    categoryLabel: 'Categorie',
    new: 'Nieuwe collectie',
    noCategory: 'U beheert nog geen enkele categorie. Vraag een platformbeheerder om u als uitgever toe te voegen.',
    empty: 'Nog geen collecties. Maak er een om documenten te groeperen.',
    documentsCount: '{{count}} documenten',
    systemBadge: 'Systeem',
    uncategorizedHint:
      'Systeemstandaard — documenten zonder collectie komen hier terecht. Kan niet hernoemd of verwijderd worden.',
    edit: 'Bewerken',
    delete: 'Verwijderen',
    confirmDelete: 'Collectie “{{name}}” verwijderen? Dit kan niet ongedaan worden gemaakt.',
    hasDocuments: 'Deze collectie bevat nog documenten — verplaats of verwijder ze eerst.',
    dialog: {
      createTitle: 'Een collectie maken',
      editTitle: 'Collectie bewerken',
      name: 'Naam',
      namePlaceholder: 'bv. Circet',
      slug: 'Slug (optioneel)',
      slugHint:
        'Kleine letters, cijfers en koppeltekens. Gebruikt in sync/drop-paden — kan later niet worden gewijzigd. Automatisch gegenereerd uit de naam indien leeg.',
      description: 'Beschrijving (optioneel)',
      descriptionPlaceholder: 'Wat deze collectie groepeert…',
      create: 'Maken',
      creating: 'Maken…',
      save: 'Opslaan',
      saving: 'Opslaan…',
    },
    toast: {
      created: 'Collectie “{{name}}” gemaakt.',
      updated: 'Collectie bijgewerkt.',
      deleted: 'Collectie verwijderd.',
    },
  },
  channels: {
    title: 'Dropmappen',
    subtitle:
      'Koppel een bewaakte SFTP/sync-map aan een collectie. Elke HTML die daar wordt neergezet, wordt automatisch in die collectie gepubliceerd en is leesbaar voor iedereen die er al toegang toe heeft — geen beheer per bestand.',
    categoryLabel: 'Categorie',
    new: 'Nieuwe dropmap',
    noCategory: 'U beheert nog geen enkele categorie. Vraag een platformbeheerder om u als uitgever toe te voegen.',
    empty: 'Nog geen dropmappen. Maak er een zodat een pipeline kan publiceren door bestanden neer te zetten.',
    intoCollection: 'Publiceert in',
    copyPath: 'Pad kopiëren',
    delete: 'Verwijderen',
    confirmDelete: 'Dropmap “{{name}}” verwijderen? Reeds gepubliceerde documenten behouden hun toegang.',
    dialog: {
      title: 'Een dropmap maken',
      subtitle: 'Kies de collectie waarin hier neergezette bestanden gepubliceerd moeten worden.',
      collection: 'Collectie',
      collectionPlaceholder: 'Selecteer een collectie…',
      noCollections: 'Maak eerst een collectie en koppel er dan een dropmap aan.',
      label: 'Label (optioneel)',
      labelPlaceholder: 'bv. Circet wekelijkse rapporten',
      create: 'Maken',
      creating: 'Maken…',
    },
    toast: {
      created: 'Dropmap gemaakt.',
      deleted: 'Dropmap verwijderd.',
    },
  },
  guide: {
    basic: {
      eyebrow: 'Gids',
      title: 'Welkom bij UniPortal',
      intro: 'UniPortal is uw beveiligde leesruimte — de documenten die met u zijn gedeeld, op één plek.',
      cards: {
        documents: { title: 'Uw documenten', body: 'U ziet alleen de documenten die met u zijn gedeeld, gegroepeerd per categorie en collectie op uw pagina Documenten.' },
        reading: { title: 'Een document lezen', body: 'Klik op een document om het te openen in een beveiligde, alleen-lezen viewer in een nieuw tabblad. Er wordt niets naar uw apparaat gedownload.' },
        access: { title: 'Een document nodig?', body: 'Ontbreekt een document dat u verwacht? Vraag het team dat documenten met u deelt om u toegang te verlenen.' },
        security: { title: 'Aanmelden', body: 'Uw account is beveiligd met een wachtwoord en een 6-cijferige authenticatorcode, of met uw Microsoft-account.' },
      },
    },
    hero: {
      eyebrow: 'Gids',
      title: 'Hoe UniPortal werkt',
      intro: 'Met UniPortal publiceren interne teams op zichzelf staande documenten en delen ze die veilig met externe gebruikers — geen wachtwoorden of door te sturen links, gewoon toegang verleend aan de juiste personen.',
      flow: {
        publish: { title: 'Publiceren', body: 'Een team uploadt een document' },
        organise: { title: 'Ordenen', body: 'Het komt in collecties terecht' },
        grant: { title: 'Toekennen', body: 'Toegang wordt aan gebruikers gegeven' },
        read: { title: 'Lezen', body: 'Zij lezen het, alleen-lezen' },
      },
    },
    hierarchy: {
      title: 'De hiërarchie',
      subtitle: 'Categorieën bevatten collecties, die documenten bevatten.',
      publisherTag: 'Categorie · interne ruimte',
      publisherExample: 'HC-aannemersrapporten',
      collections: { circet: 'Circet', ctl: 'CTL', nonCollection: 'Niet-gecategoriseerd' },
      doc: {
        circet: { 0: 'Weekrapport — wk 23', 1: 'Werfaudit — Antwerpen' },
        ctl: { 0: 'Voortgangsrapport — mei', 1: 'Kwaliteitschecklist' },
        nonCollection: { 0: 'Startnotities', 1: 'Diverse overdracht' },
      },
      nonCollectionNote: 'Een systeemmap, één per categorie, die automatisch elk document bevat dat niet in een collectie is ondergebracht.',
      legend: {
        publisher: { term: 'Categorie', def: 'een interne ruimte van Unifiber die documenten publiceert.' },
        collection: { term: 'Collectie', def: 'een benoemde groep documenten, bijv. één per aannemer.' },
        document: { term: 'Document', def: 'één op zichzelf staand HTML-bestand dat met gebruikers wordt gedeeld.' },
      },
    },
    m2m: {
      title: 'Veel-op-veel-koppelingen',
      subtitle: 'Eén enkel document kan op meerdere plaatsen tegelijk staan — het subtiele punt.',
      inBadge: 'staat in',
      linkBadge: 'koppelt aan',
      docCollections: {
        title: 'Eén document, meerdere collecties',
        body: 'Hetzelfde document kan in meerdere collecties tegelijk worden ondergebracht. Het verschijnt onder elk ervan, maar er zit slechts één document achter.',
        doc: 'Document',
        col: { circet: 'Circet', shared: 'Gedeelde rapporten' },
      },
      docPublishers: {
        title: 'Eén document, meerdere categorieën',
        body: 'Als een tweede categorie exact hetzelfde bestand uploadt, detecteert UniPortal het duplicaat en koppelt het bestaande document in plaats van een kopie op te slaan.',
        deptA: 'Categorie A',
        deptB: 'Categorie B',
        primary: 'Eigenaar',
        secondary: 'Gekoppeld',
        oneDoc: 'Eén document',
        note: 'De eigenaarscategorie is primair. Een tweede categorie beheert haar eigen collecties en toegang voor het document, maar kan het niet verwijderen.',
      },
    },
    access: {
      title: 'Wie ziet wat',
      subtitle: 'Een externe gebruiker ziet alleen de documenten die aan hem zijn toegekend.',
      or: 'OF',
      pathA: { tag: 'Weg A', title: 'Een hele collectie toekennen', body: 'De gebruiker kan elk document in die collectie lezen — ook documenten die later worden toegevoegd.' },
      pathB: { tag: 'Weg B', title: 'Eén enkel document toekennen', body: 'De gebruiker kan alleen dat ene document lezen, ongeacht tot welke collecties het behoort.' },
      result: { title: 'Een gebruiker ziet een document als één van beide wegen geldt', body: 'Hij heeft een directe toekenning op het document, OF een toekenning op een collectie waarin het document zit.' },
      formula: { visible: 'Kan zien', docGrant: 'documenttoekenning', or: 'OF', colGrant: 'toekenning op één van zijn collecties' },
    },
    roles: {
      title: 'Rollen & rechten',
      subtitle: 'Drie soorten accounts, met sterk verschillende bevoegdheden.',
      scopeLabel: 'Bereik',
      viewer: {
        name: 'Gewone lezer',
        tagline: 'Externe lezer',
        summary: 'Logt in om de met hem gedeelde documenten te lezen — meer niet. Een opgeruimde leesruimte, alleen-lezen.',
        can: ['Veilig inloggen (wachtwoord + 2FA, of Microsoft)', 'Alleen de aan hem toegekende documenten zien', 'Documenten lezen in een afgeschermde viewer'],
        scope: 'Alleen zijn eigen toegekende documenten',
      },
      publisher: {
        name: 'Uitgever',
        tagline: 'Publicatiemedewerker',
        summary: 'Publiceert en beheert de documenten en collecties van één of meer categorieën en beslist wie ze mag lezen.',
        can: ['Documenten uploaden en bewerken voor zijn categorie(ën)', 'Collecties aanmaken en ordenen', 'Toegang verlenen aan elke gebruiker op het platform'],
        scope: 'Alleen de categorieën waartoe hij behoort',
      },
      admin: {
        name: 'Platformbeheerder',
        tagline: 'Volledige controle',
        summary: 'Beheert het hele platform — elke categorie, elke gebruiker, elk document en elke collectie.',
        can: ['Alle categorieën beheren', 'Alle gebruikersaccounts aanmaken en beheren', 'Toezicht houden op elk document, elke collectie en toekenning'],
        scope: 'Het volledige platform',
      },
    },
  },
} as const;
